import { VFC } from 'react';
import { SENSOR_SCAN_STEP_FORM } from 'consts/common';
import { useInstallMeterStepsStore } from 'routes/installation/components/store';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../../components/Button/Button';
import { useStore } from '../../useStore';
import { selectIsInstallMeterSensorStepOK } from './selectors';
import { InstallationTechnology } from '../../const/installationTechnology';
import { SensorScanStepFooter as messages } from './messages';

export const SensorScanStepFooter: VFC = () => {
  const { installationTechnology } = useStore();
  const { setPreviousStep } = useInstallMeterStepsStore();
  const isStepOK = useStore(selectIsInstallMeterSensorStepOK);

  return (
    <>
      <Button block style={{ marginRight: 15 }} onClick={() => setPreviousStep()}>
        <FormattedMessage {...messages.back} />
      </Button>
      <Button key="submit" block disabled={isStepOK} form={SENSOR_SCAN_STEP_FORM} htmlType="submit" type="primary">
        {installationTechnology === InstallationTechnology.LoraWan ? (
          <FormattedMessage {...messages.verifyConnection} />
        ) : (
          <FormattedMessage {...messages.continue} />
        )}
      </Button>
    </>
  );
};
